import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType, CodeBlock, BlockType, ValidationMessage, ValidationMessageType,
    SettingState,
    SettingOption,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import Tbl from '@appblocks/codegeneration/Libraries/Tbl';

export default class ConsolTableItem extends BaseFeature {
    constructor() {
        super();
        this.name = 'Table';
        this.id = 'console_table_item';
        this.singleInstance = false;
        this.settings = this.settings.concat([
            {
                id: 'TABLE',
                name: 'Table',
                settingType: SettingType.OPTION,
                required: true,
                refId: 'tbl_table',
                default: '',
            },
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
        ]);
    }
}
